$(document).ready(function() {
    const form = $('form[action="/cart"]');

    // Fetch cart items from the server
    const fetchCartItems = async () => {
        const response = await fetch('/cart.json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    };

    form.on('submit', async function(evt) {
        console.log('Form submission event triggered'); 
        evt.preventDefault(); 

        try {
            const items = await fetchCartItems(); 
            console.log('Fetched cart items:', items.items); 

            const today = new Date();
            today.setHours(0, 0, 0, 0); 

            const promises = []; 
            let preventSubmission = false; 

            for (const item of items.items) {
                if (item.properties?._reqDate) {
                    const itemReqDate = new Date(item.properties._reqDate);
                    console.log('Comparing dates:', today, itemReqDate);

                    if (today > itemReqDate) {
                        console.log(`Today's date is greater than the item value: ${item.properties._reqDate}`);
                        promises.push(atpRequest(item)); 
                        preventSubmission = true; 
                    } else {
                        console.log("No date changes");
                    }
                }
            }

            if (preventSubmission) {
                await Promise.all(promises); 
                console.log("All date updates completed.");
            } else {
                console.log("Form submission allowed.");
            }

            console.log(preventSubmission ? "Form submission prevented." : "Form submission allowed.");
            window.location.href = '/checkout'; 
        } catch (error) {
            console.error('Error fetching cart items:', error); 
        }finally{
          
        }
    });

    async function atpRequest(item) {
        if (!item.sku) {
            return Promise.resolve(); 
        }

        const countryCode = localStorage.getItem('country_code');
        const qty = item.quantity;
        const custNum = countryCode === 'US' ? '4700' : '6700';
        const atpUrl = 'https://brandography-dev.dreamhosters.com/atpLogic.php';
        const requestObj = {
            CustNbr: custNum,
            FromDepot: "false",
            AtpRequestDetail: [{ PartNbr: item.sku, Qty: qty, RequestedDate: new Date() }]
        };

        try {
            const response = await fetch(atpUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestObj)
            });

            if (!response.ok) throw new Error("Network response was not ok");

            const data = await response.json();
            const atpDetail = data.oResults.AtpRequestDetail[0];
            const { AtpDate, TsdDate, AtpSuccess, ErrorMessage } = atpDetail;

            let shipDate, deliveryDate;

            if (ErrorMessage?.includes("Bad part")) {
                console.log("Bad part error");
                shipDate = "TBD";
                deliveryDate = ""; 
                return updateItem(item, shipDate, deliveryDate);
            }

            const isAtpSuccess = AtpSuccess === "true";
            const futureDate = new Date();

            if (!AtpDate && !TsdDate) {
                shipDate = formatDate(isAtpSuccess ? futureDate.setDate(futureDate.getDate() + 1) : futureDate.setDate(futureDate.getDate() + 21));
            } else {
                const targetDate = isAtpSuccess ? (TsdDate ? new Date(TsdDate) : futureDate) : new Date(AtpDate);
                shipDate = formatDate(targetDate);
            }

            deliveryDate = formatDate(new Date(new Date(shipDate).setDate(new Date(shipDate).getDate() + 5)));

            return updateItem(item, shipDate, deliveryDate);
        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.message.includes("503")) {
                console.log("503 error occurred. Setting dates based on requested date.");
                const requestedDate = new Date(item.properties._reqDate);
                const shipDate = formatDate(new Date(requestedDate.setDate(requestedDate.getDate() + 2)));  // +2 days
                const deliveryDate = formatDate(new Date(new Date(shipDate).setDate(new Date(shipDate).getDate() + 4)));  // +4 days from shipping date
    
                return updateItem(item, shipDate, deliveryDate);
            }          
        }
    }

    async function updateItem(item, shipDate, deliveryDate) {
        const formData = {
            id: item.key,
            properties: { 'Estimated Ship Date': shipDate, 'Estimated Delivery Date': deliveryDate, '_reqDate': new Date() }
        };

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            await response.json();
            console.log(`Successfully updated date for: ${item.title}`, shipDate, deliveryDate);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    }
});
